// Share button + sheet trigger (handoff 6, AC-B-019). Demo-only: in live mode the
// raw invite token was exchanged and discarded (AC-B-025), so the app cannot
// reconstruct the invite URL to share. Demo mode shares the synthetic demo link.

import { useState } from 'react';
import { ShareSheet } from './ShareSheet';
import { ShareNetwork } from '../lib/icons';
import { isDemoMode } from '../lib/api';

function demoInviteUrl(): string {
  return `${window.location.origin}/feedback/#t=demo`;
}

export function ShareButton() {
  const [open, setOpen] = useState(false);
  if (!isDemoMode()) return null;
  return (
    <>
      <button
        type="button"
        className="btn btn-icon"
        aria-label="分享反馈链接"
        title="分享反馈链接"
        onClick={() => setOpen(true)}
      >
        <ShareNetwork weight="regular" aria-hidden="true" />
      </button>
      <ShareSheet open={open} inviteUrl={demoInviteUrl()} onClose={() => setOpen(false)} />
    </>
  );
}
